import { create } from "zustand"

type EditProjectTypeDialogState = {
  isOpen: boolean
}

type EditProjectTypeDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useEditProjectTypeDialog = create<
  EditProjectTypeDialogState & EditProjectTypeDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useEditProjectTypeDialog
